module.exports = __webpack_public_path__ + "static/c5-bd8ed9959544df8385b74fa1e8a44f28.jpg";